import { useEffect, useState } from "react";

import type {
  OptionalQuizModelType,
  QuizModelType,
  ResultModelType,
  ResultsModelType,
} from "@/components/FlavorFinder/api";
import { QuizModel } from "@/components/FlavorFinder/api";
import { useLocale } from "@/context/LocaleContext";
import { fetchBuilderEntries } from "@/libs/builder/tools/fetchBuilderEntries";
import { getAllEntries } from "@/libs/builder/tools/getAllEntries";

export const useQuiz = (
  finalQuestion: OptionalQuizModelType | undefined,
  resultsLink = "",
  resultsLinkWithDevice = ""
) => {
  const { currentLocale } = useLocale();

  const [quizModel, setQuizModel] = useState(() => new QuizModel([], [], [], undefined, "", ""));

  useEffect(() => {
    Promise.all([
      getAllEntries(async ({ limit, offset }) => {
        const items = await fetchBuilderEntries({
          locale: currentLocale,
          model: "flavor-finder-question",
          limit,
          offset,
        });

        return {
          items,
          totalFetched: items.length,
        };
      }) as Promise<QuizModelType[]>,
      getAllEntries(async ({ limit, offset }) => {
        const items = await fetchBuilderEntries({
          locale: currentLocale,
          model: "flavor-finder-results",
          limit,
          offset,
        });

        return {
          items,
          totalFetched: items.length,
        };
      }) as Promise<ResultsModelType[]>,
      getAllEntries(async ({ limit, offset }) => {
        const items = await fetchBuilderEntries({
          locale: currentLocale,
          model: "flavor-finder-result",
          limit,
          offset,
        });

        return {
          items,
          totalFetched: items.length,
        };
      }) as Promise<ResultModelType[]>,
    ]).then(([quizzesModel, resultsModel, resultModel]) => {
      const quizModel = new QuizModel(
        quizzesModel,
        resultsModel,
        resultModel,
        finalQuestion,
        resultsLink,
        resultsLinkWithDevice
      );

      setQuizModel(quizModel);
    });
  }, [currentLocale, finalQuestion, resultsLink, resultsLinkWithDevice]);

  return quizModel;
};
